import React, { FC } from "react";
import laptopAlertSign from "@/assets/studentTile/laptop-alert-sign.svg?url";
import { Button, Image, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import IconTileContentLayout from "js/components/StudentTile/components/IconTileContentLayout";

interface CannotDisplayScreenProps {
	useIssueOngoing: () => void;
}

const CannotDisplayScreen: FC<CannotDisplayScreenProps> = (props: CannotDisplayScreenProps) => {
	const { t } = useTranslation();
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex flexDirection={"column"} align={"center"} justifyContent={"center"} height={"100%"}>
			<IconTileContentLayout>
				{tileSize !== "sm" && <Image src={laptopAlertSign} htmlHeight={42} htmlWidth={42} mb={tileSize === "lg" ? 4 : 1} />}
				<Text fontWeight={"bold"} lineHeight={1.2}>
					{t("studentTile.cannotDisplayScreenTitle")}
				</Text>
				<Text lineHeight={1.2}>
					{tileSize === "sm" ? t("studentTile.cannotDisplayScreenSubtitleShort") : t("studentTile.cannotDisplayScreenSubtitle")}
				</Text>
				<Button
					size="sm"
					py={2}
					px={4}
					mb={tileSize === "lg" ? 4 : 0}
					mt={tileSize !== "sm" ? 4 : 0}
					variant={"outline"}
					fontSize={12}
					backgroundColor={"#f8f8f9"}
					onClick={() => props.useIssueOngoing()}
				>
					{t("studentTile.cannotDisplayScreenButton")}
				</Button>
			</IconTileContentLayout>
		</Flex>
	);
};

export default CannotDisplayScreen;
